export const routes = [
  {
    path: '/',
    breadcrumb: 'Login'
  },
  {
    path: '/registro',
    breadcrumb: 'Registro'
  },
  {
    path: '/recuperar-cuenta',
    breadcrumb: 'Recuperar cuenta'
  },
  {
    path: '/terminos-condiciones',
    breadcrumb: 'Términos y condiciones'
  },

  {
    path: '/inicio',
    breadcrumb: 'Inicio'
  },
  {
    path: '/inicio/nueva-contrasenia',
    breadcrumb: 'Nueva contraseña'
  },
  {
    path: '/inicio/perfil',
    breadcrumb: 'Perfil'
  },
  {
    path: '/inicio/novedades',
    breadcrumb: 'Novedades'
  },
  {
    path: '/inicio/novedades/tomografia-sin-contraste',
    breadcrumb: 'Tomografía sin contraste'
  },
  {
    path: '/inicio/novedades/radiografias',
    breadcrumb: 'Radiografías'
  },
  {
    path: '/inicio/novedades/radiografias-panoramicas',
    breadcrumb: 'Radiografías panorámicas'
  },
  {
    path: '/inicio/novedades/ecografias',
    breadcrumb: 'Ecografías'
  },
  {
    path: '/inicio/novedades/mamografias',
    breadcrumb: 'Mamografías'
  },
  {
    path: '/inicio/novedades/resonancias-sin-contraste',
    breadcrumb: 'Resonancias sin contraste'
  },
  {
    path: '/inicio/formulario-de-contacto',
    breadcrumb: 'Formulario de contacto'
  },
  {
    path: '/inicio/contacto',
    breadcrumb: 'Contacto'
  },

  {
    path: '/inicio/mis-datos',
    breadcrumb: 'Mis datos'
  },
  {
    path: '/inicio/mis-datos/cambiar-contrasenia',
    breadcrumb: 'Cambiar contraseña'
  },
  {
    path: '/inicio/mis-datos/cambiar-email',
    breadcrumb: 'Cambiar email'
  },
  {
    path: '/inicio/mis-datos/cambiar-telefono',
    breadcrumb: 'Cambiar número de celular'
  },
  {
    path: '/inicio/mis-datos/cambiar-nombre-y-apellido',
    breadcrumb: 'Cambiar nombre y apellido'
  },
  {
    path: '/inicio/mis-turnos',
    breadcrumb: 'Mis turnos'
  },
  {
    path: '/inicio/mis-turnos/detalle',
    breadcrumb: 'Detalle del turno'
  },

  {
    path: '/inicio/gestionar-turnos',
    breadcrumb: 'Gestionar turnos'
  },
  {
    path: '/inicio/turnos',
    breadcrumb: 'Turnos'
  },
  {
    path: '/inicio/ordenes',
    breadcrumb: 'Ordenes'
  },
  {
    path: '/inicio/gestionar-turnos/centro-de-la-mujer',
    breadcrumb: 'Centro de la mujer'
  },
  {
    path: '/inicio/gestionar-turnos/medicina-deportiva',
    breadcrumb: 'Medicina deportiva'
  },
  {
    path: '/inicio/guardia-smart',
    breadcrumb: 'Guardia smart'
  },
  {
    path: '/inicio/guardia-smart/guardia-clinica',
    breadcrumb: 'Guardia clínica'
  },
  {
    path: '/inicio/pacientes-internados',
    breadcrumb: 'Pacientes internados'
  },
  {
    path: '/inicio/aranceles',
    breadcrumb: 'Aranceles'
  },
  {
    path: '/inicio/roles',
    breadcrumb: 'Roles'
  },
  {
    path: '/inicio/usuarios',
    breadcrumb: 'Usuarios'
  },
  {
    path: '/inicio/usuarios/nuevo',
    breadcrumb: 'Nuevo usuario'
  },
  {
    path: '/inicio/usuarios/modificar',
    breadcrumb: 'Modificar usuario'
  },
  {
    path: '/inicio/usuarios/nuevo/confirmar',
    breadcrumb: 'Confirmar datos'
  },
  {
    path: '/inicio/usuarios/modificar/confirmar',
    breadcrumb: 'Confirmar datos'
  },
  {
    path: '/inicio/logs',
    breadcrumb: 'Reporte de Accesos'
  },
  {
    path: '/inicio/laboratorios',
    breadcrumb: 'Resultados de laboratorio'
  },
  {
    path: '/inicio/laboratorios/confirmar',
    breadcrumb: 'Confirmar datos del paciente'
  },
  // {
  //   path: '/inicio/videoconsulta',
  //   breadcrumb: 'Videoconsulta'
  // },
  // {
  //   path: '/inicio/videoconsulta/turnos',
  //   breadcrumb: 'Turnos'
  // },
  // {
  //   path: '/inicio/videoconsulta-medico',
  //   breadcrumb: 'Videoconsulta médico'
  // },
  {
    path: '/inicio/facturacion',
    breadcrumb: 'Facturación'
  },
  {
    path: '/inicio/menu',
    breadcrumb: 'menu'
  },
  {
    path: '/inicio/mis-turnos',
    breadcrumb: 'Mis turnos'
  },
  {
    path: '/inicio/programar-turnos',
    breadcrumb: 'Turnos'
  },
  {
    path: '/inicio/guardia',
    breadcrumb: 'Ingresar a la guardia'
  },
]